export const getIsPhoenixV2 = (integationExternalReference?: string): boolean => {
  if (!integationExternalReference) return false
  else return integationExternalReference.includes('finance_id')
}
